"use client";
import Link from "next/link";
import { useState } from "react";
import { ImArrowUpRight2 } from "react-icons/im";

const featuresData = [
  {
    bgClass: "bg-1",
    title: "Inspire, Participate, and Achieve Together",
    description:
      "Experience a campus filled with dynamic events that nurture talent, leadership, and lifelong memories.",
    icon: "/diagonal-arrow-right-up.svg",
  },
  {
    bgClass: "bg-2",
    title: "Shape Your Career with Excellence",
    description:
      "Join a community that blends academic strength, advanced technology, and real-world opportunities for your bright future.",
    icon: "/diagonal-arrow-right-up.svg",
  },
  {
    bgClass: "bg-3",
    title: "Step Into a Smarter Tomorrow",
    description:
      "Experience modern classrooms, innovative labs, and a vibrant campus culture that inspires creativity and growth.",
    icon: "/diagonal-arrow-right-up.svg",
  }
];

const FeaturesAreaTwoClient = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <>
      {featuresData.map((feature, idx) => (
        <div
          key={idx}
          className={`slide position-relative ${feature.bgClass} ${
            activeIndex === idx ? "active" : ""
          }`}
          onClick={() => setActiveIndex(idx)}
          style={{ cursor: "pointer" }}
        >
          <div className="features-content d-lg-flex align-items-center justify-content-between">
            <div className="content">
              <h3 className="fw-semibold fs-4">{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
            <Link
              href={"contact"}
              className="link-btn d-inline-block text-center rounded-circle fw-medium"
            >
              <span className="d-block ">Contact Us</span>
                <ImArrowUpRight2 size={25} className="brn"/>

            </Link>
          </div>
        </div>
      ))}
    </>
  );
};

export default FeaturesAreaTwoClient;
